@if (initialized && dto) {
    <div class="grid">
        <div class="col-12">
            <mvs-crud-object
                    [objectType]="objectIdentifier.objectType"
                    [objectId]="objectIdentifier.objectId"
            ></mvs-crud-object>
        </div>
    </div>
}
